/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import React, {FC} from 'react'
import {Link} from 'react-router-dom'
import {useAuth} from '../../../../app/modules/auth/core/Auth'
import {KTSVG} from '../../../helpers'
import {useLayout} from '../../core'
import {AsideMenu} from './AsideMenu'

const AsideDefault: FC = () => {
  const {auth} = useAuth()
  const {config, classes} = useLayout()
  const {aside} = config

  return (
    <div
      id='kt_aside'
      className={clsx('aside', classes.aside.join(' '))}
      data-kt-drawer='true'
      data-kt-drawer-name='aside'
      data-kt-drawer-activate='{default: true, lg: false}'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'200px', '300px': '250px'}"
      data-kt-drawer-direction='start'
      data-kt-drawer-toggle='#kt_aside_mobile_toggle'
    >
      {/* begin::Brand */}
      <div className='aside-logo flex-column-auto' id='kt_aside_logo'>
        {/* begin::Logo */}
        {aside.theme === 'dark' && (
          <div className='text-center div-logo'>
            <Link to='/'>
              <img
                alt='Logo'
                className='logo'
                // src='/media/avatars/Logo_HN.png'
                // src={IMG_LOGO_APP}
                src={auth?.configs.imgLogoLogin}
              />
              <span className='logo' style={{color: 'white', fontWeight: 'bold'}}>
                {auth?.configs.textApp} {auth?.configs.textLogoApp}
              </span>
            </Link>
          </div>
        )}
        {/* <p className='p-logo'>Hệ thống truyền thanh thông minh <span style={{ color: '#1C96D4' }}>Hà Nội</span></p> */}
        {aside.theme === 'light' && (
          <Link to='/'>
            <img
              alt='Logo'
              className='h-45px logo'
              // src='/media/avatars/Logo_HN.png'
              src={auth?.configs.imgLogoApp}
              // src={IMG_LOGO_APP}
            />
          </Link>
        )}
        {/* end::Logo */}

        {/* begin::Aside toggler */}
        {aside.minimize && (
          <div
            id='kt_aside_toggle'
            className='btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle'
            data-kt-toggle='true'
            data-kt-toggle-state='active'
            data-kt-toggle-target='body'
            data-kt-toggle-name='aside-minimize'
          >
            <KTSVG
              path={'/media/icons/duotune/arrows/arr080.svg'}
              className={'svg-icon-1 rotate-180'}
            />
          </div>
        )}
        {/* end::Aside toggler */}
      </div>
      {/* end::Brand */}

      {/* begin::Aside menu */}
      <div className='aside-menu flex-column-fluid' style={{position: 'relative'}}>
        <AsideMenu asideMenuCSSClasses={classes.asideMenu} />
        {/* <div className='copyright-logos'>
          {window.location.host === 'htttn.truyenthanhso.com' ? null : (
            <span> ® {auth?.configs.copyRight ?? 'BYTECH'}</span>
          )}
        </div> */}
      </div>
      {/* end::Aside menu */}
    </div>
  )
}

export {AsideDefault}
